import { OrderDialogOrderItemDto } from './order-dialog-order-item.dto';
import { IsArray, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Min, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class OrderDialogUpdateOrderContentRequest {
  @IsNotEmpty()
  @IsInt()
  orderId: number;

  @IsNotEmpty()
  @IsArray()
  @ValidateNested() // Tells validator to check inside this object
  @Type(() => OrderContentDto)
  orderContent: OrderContentDto[];
}

class OrderContentDto {
  @IsNotEmpty()
  @IsInt()
  orderItemId: number;

  @IsNotEmpty()
  @IsString()
  productName: string;

  @IsNotEmpty()
  @IsNumber()
  quantity: number;

  @IsNotEmpty()
  @IsNumber({ maxDecimalPlaces: 2 })
  @Min(0)
  price: number;

  @IsOptional()
  @IsArray()
  @ValidateNested() // Tells validator to check inside this object
  @Type(() => ModifierContentDto)
  modifiers: ModifierContentDto[];
}

export class ModifierContentDto {
  @IsNotEmpty()
  @IsInt()
  modifierId: number;

  @IsNotEmpty()
  @IsString()
  modifierName: string;

  @IsNotEmpty()
  @IsNumber()
  quantity: number;

  @IsNotEmpty()
  @IsNumber({ maxDecimalPlaces: 2 })
  @Min(0)
  price: number;
}